import React from "react";

import SemanticModifiers from "./SemanticModifiers";

export default function AgentModifiers() {
  return <SemanticModifiers />;
}
